import { Button, Container } from '@playcanvas/pcui';

import { Events } from '../events';
import { localize } from './localization';
import pictureSvg from './svg/image.svg';
import { Tooltips } from './tooltips';

const createSvg = (svgString: string) => {
    const decodedStr = decodeURIComponent(svgString.substring('data:image/svg+xml,'.length));
    return new DOMParser().parseFromString(decodedStr, 'image/svg+xml').documentElement;
};

class PictureButton extends Container {
    constructor(events: Events, tooltips: Tooltips, args = {}) {
        args = {
            ...args,
            id: 'picture-button-container'
        };

        super(args);

        this.dom.addEventListener('pointerdown', (event) => {
            event.stopPropagation();
        });

        const showAssociatedPicture = new Button({
            id: 'picture-button',
            class: 'picture-button'
        });

        showAssociatedPicture.dom.appendChild(createSvg(pictureSvg));

        this.append(showAssociatedPicture);

        tooltips.register(showAssociatedPicture, localize('tooltip.show-associated-picture'), 'right');

        showAssociatedPicture.on('click', async () => {
            const file = await events.invoke('images.closestToCamera', { angleWeight: 0.6, withPopups: true });
            if (file) {
                events.fire('associatedPicturePanel.setImageSrc', file);
                events.fire('show-associated-picture');
            } else {
                await events.invoke('showPopup', {
                    type: 'error',
                    header: localize('popup.error-loading'),
                    message: `Error while loading file, please ensure the images & image configuration file is loaded.`
                });
            }
        });
    }
}

export { PictureButton };
